<template>
  <a-popover trigger="hover">
    <template slot="content">
      <p>{{ content }}</p>
    </template>
    <a-icon type="exclamation-circle" style="color: #f37b1d" />
  </a-popover>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default() {
        return '建议图片大小为：宽：400，高：300，效果最佳'
      },
    },
  },
}
</script>
